import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, Ref } from 'vue';
import { props as propsDefinition } from './popper.shared';
import { StPopper } from './popper.styled';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkPopper',
  props: propsDefinition,
  setup(__props) {

const props = __props



const reference: Ref<HTMLElement | null> = ref(null);
const content = ref(null);

const randomKey = computed(() => Math.random().toString(36).substring(2, 7));

const getReferenceWidth = computed(() => {
  if (!props.inline) {
    return 'auto';
  }

  const width = (reference.value?.getBoundingClientRect().width || 250);

  if (props.refreshKey) {
    return width;
  }

  return width;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StPopper), _mergeProps({
    key: _unref(randomKey),
    class: ["nk-popper", {'nk-popper-styled': props.styled}]
  }, {..._ctx.$attrs, ..._ctx.$props}), {
    content: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "content",
        ref: content,
        style: _normalizeStyle({width: `${_unref(getReferenceWidth)}px`})
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "reference",
        ref: reference
      }, [
        _renderSlot(_ctx.$slots, "reference")
      ], 512)
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})